<script>
import { getCaptchaConfig } from "@/api/configs";

export default {
    name: "Captcha",
    data: () => ({
        captcha: null,
        loading: false,
    }),
    props: {
        config: String,
        altInfo: {
            type: String,
            default: "",
        },
    },
    computed: {},
    created() {
        this.getCaptchaConfig();
    },
    methods: {
        async reload() {
            await this.getCaptchaConfig();
        },
        async getCaptchaConfig() {
            this.loading = true;
            try {
                const { data } = await getCaptchaConfig(this.config);
                this.captcha = data;
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        captcha(newVal) {
            this.$emit("captcha", newVal);
        },
    },
    render(h) {
        return (
            <div
                v-on:click={this.getCaptchaConfig}
                class="captcha-wrapper"
                title={this.$loginTL.ClickToRefresh}
            >
                <svg viewBox="0 0 24 24" class="loading-icon">
                    <path
                        fill="#888888"
                        d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z"
                    />
                </svg>
                <img v-show={!this.loading} src={this.captcha?.img} />
            </div>
        );
    },
};
</script>

<style lang="scss">
.captcha {
    margin-left: 32px;
    flex-shrink: 0;

    .captcha-wrapper {
        width: 112px;
        height: 32px;
        margin-top: 2px;
        @include flex(center);
        position: relative;
        cursor: pointer;

        img {
            position: absolute;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 2;
            &[src=""],
            &:not([src]) {
                opacity: 0;
            }
        }
    }

    .loading-icon {
        width: 20px;
        height: 20px;
        margin: {
            left: 20px;
            top: 4px;
        }
    }
}
</style>
